import { NewDate } from '@/Domain/News'
import { Currency } from '@/Domain/Batch/Currency'
import { DefinitiveWarrantyRefund } from '@/Domain/Expediente'

export class DefinitiveWarrantyRefundDto {
  private _tipoDevolucion: string
  private _importeDevolucion: Currency | null
  private _dataDevolucion: NewDate | null
  private _refundCause: string | null
  private _incautationDate: string | null
  private _incautationAmount: string | null
  private _refundToPropertyDate: string | null
  private _restrictionCause: string | null
  private _restrictionResolutionDate: string | null
  private _restrictionAmount: string | null
  private _restrictionEndingDate: string | null

  static fromDefinitive (def: DefinitiveWarrantyRefund): DefinitiveWarrantyRefundDto {
    return new DefinitiveWarrantyRefundDto(
      def.tipoDevolucion,
      def.importeDevolucion,
      def.dataDevolucion ? new NewDate(def.dataDevolucion) : null,
      def.refundCause,
      def.incautationDate,
      def.incautationAmount,
      def.refundToPropertyDate,
      def.restrictionCause,
      def.restrictionResolutionDate,
      def.restrictionAmount,
      def.restrictionEndingDate
    )
  }

  constructor (
    tipoDevolucion: string,
    importeDevolucion: Currency | null,
    dataDevolucion: NewDate | null,
    refundCause: string | null,
    incautationDate: string | null,
    incautationAmount: string | null,
    refundToPropertyDate: string | null,
    restrictionCause: string | null,
    restrictionResolutionDate: string | null,
    restrictionAmount: string | null,
    restrictionEndingDate: string | null
  ) {
    this._tipoDevolucion = tipoDevolucion
    this._importeDevolucion = importeDevolucion
    this._dataDevolucion = dataDevolucion
    this._refundCause = refundCause
    this._incautationDate = incautationDate
    this._incautationAmount = incautationAmount
    this._refundToPropertyDate = refundToPropertyDate
    this._restrictionCause = restrictionCause
    this._restrictionResolutionDate = restrictionResolutionDate
    this._restrictionAmount = restrictionAmount
    this._restrictionEndingDate = restrictionEndingDate
  }

  get tipoDevolucion (): string {
    return this._tipoDevolucion
  }

  get importeDevolucion (): Currency {
    if (this._importeDevolucion !== null) {
      return this._importeDevolucion
    } else { return new Currency(0) }
  }

  get dataDevolucion (): string {
    if (this._dataDevolucion !== null) {
      return this._dataDevolucion.date()
    } else { return '' }
  }

  get refundCause (): string | null {
    return this._refundCause
  }

  get incautationDate (): string | null {
    return this._incautationDate
  }

  get incautationAmount (): string | null {
    return this._incautationAmount
  }

  get refundToPropertyDate (): string | null {
    return this._refundToPropertyDate
  }

  get restrictionCause (): string | null {
    return this._restrictionCause
  }

  get restrictionResolutionDate (): string | null {
    return this._restrictionResolutionDate
  }

  get restrictionAmount (): string | null {
    return this._restrictionAmount
  }

  get restrictionEndingDate (): string | null {
    return this._restrictionEndingDate
  }
}
